import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

export const CONNECTION_EVENT = "sanvalle:connection";
const signal = (kind) => window.dispatchEvent(new CustomEvent(CONNECTION_EVENT, { detail: kind }));

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config || {};
    const url = orig.url || "";
    if (!error.response && error.code !== "ERR_CANCELED") signal("offline");
    if (error.response?.status === 401 && !orig._retry && !url.includes("/auth/refresh") && !url.includes("/auth/login")) {
      orig._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(orig);
      } catch (e) {
        refreshing = null;
        if (e.response?.status === 401) signal("expired");
      }
    }
    return Promise.reject(error);
  }
);

export function formatError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return detail.msg || String(detail);
}

export const brl = (v) => Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
export const num = (v, d = 2) => Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: d, maximumFractionDigits: d });
export const imgUrl = (u) => (u && u.startsWith("/api") ? `${BACKEND_URL}${u}` : u);
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" }) : "");
export const maskCpf = (v) => (v || "").replace(/\D/g, "").slice(0, 11).replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d{1,2})$/, "$1-$2");

export const STATUSES = ["Aguardando pagamento", "Pago", "Em produção", "Concluído", "Disponível para retirada"];

export const MIN_BILLED_AREA = 0.5;

export function calcItem(pricingType, price, { width, height, quantity, option }) {
  const qty = Number(quantity) || 0;
  if (option) return { area: 0, billedArea: 0, minApplied: false, subtotal: price || 0 };
  if (pricingType === "m2") {
    const area = Math.round((Number(width) || 0) * (Number(height) || 0)) / 10000;
    const billedArea = area > 0 ? Math.max(area, MIN_BILLED_AREA) : 0;
    return { area, billedArea, minApplied: area > 0 && area < MIN_BILLED_AREA, subtotal: Math.round(billedArea * price * qty * 100) / 100 };
  }
  return { area: 0, billedArea: 0, minApplied: false, subtotal: Math.round(price * qty * 100) / 100 };
}

export const paymentLabel = (m) => ({ pix: "Pix", stripe: "Cartão (Stripe)", mercadopago: "Mercado Pago", cash: "Dinheiro" }[m] || m);
export const paymentStatusLabel = (s) => ({ paid: "Pago", partial: "Parcial" }[s] || "Pendente");

export async function downloadBlob(path, filename, params) {
  const { data } = await api.get(path, { responseType: "blob", params });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export const downloadNote = (order) =>
  downloadBlob(`/orders/${order.id}/note`, `nota-${order.number}.pdf`, { email: order.customer?.email });

export const fileSize = (b) => (b >= 1048576 ? `${num(b / 1048576, 1)} MB` : b >= 1024 ? `${num(b / 1024, 0)} KB` : `${b} B`);

export async function downloadArt(file) {
  const { data } = await api.get(`/admin/files/${file.id}/download`, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = file.name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

const DISCOUNT_BADGES = {
  reseller: { label: "Preço revenda", short: "Revenda", cls: "bg-violet-100 text-violet-800" },
  vip: { label: "Preço VIP -10%", short: "VIP -10%", cls: "bg-amber-100 text-amber-800" },
};
export const discountBadge = (p) => DISCOUNT_BADGES[p?.discount_kind] || DISCOUNT_BADGES.reseller;
export const priceSuffix = (p) => (p.price_table ? "" : p.pricing_type === "m2" ? "/m²" : `/${p.unit_label || "unidade"}`);
export const tablePrice = (product, option, qty) => {
  const t = product.price_table;
  const o = t.options.indexOf(option);
  const q = t.quantities.indexOf(Number(qty));
  if (o < 0 || q < 0) return {};
  const price = t.prices[o][q];
  const regular = t.regular_prices?.[o]?.[q];
  return { price, regular: regular && regular !== price ? regular : undefined };
};
